import apiAgent from "../api/apiAgent";
import { useState } from "react";
import { tMsg } from "../components/ToastNotifications";
import { Button } from "../components/Button";
import { isValidEmail } from "../utils";
import { Link } from "react-router-dom";
import { Loader } from "../components/Loader";
import { useAtomValue } from "jotai";
import { userAtom } from "../atoms";

const RequestMFAReset = (): JSX.Element => {
  const [submitting, setSubmitting] = useState<boolean>(false);
  const [submitted, setSubmitted] = useState<boolean>(false);
  const user = useAtomValue(userAtom);

  const sendRequest = async () => {
    try {
      setSubmitting(true);
      if (!user) return;
      const response = await apiAgent.Auth.requestResetMFA({
        email: user.email,
      });
      if (response.status === 200) {
        tMsg.success(`Your reset request has been submitted`);
        setSubmitted(true);
      }
    } catch (err) {
      console.log(err);
      tMsg.error("Error sending request");
    } finally {
      setSubmitting(false);
    }
  };

  const handleSubmit = () => {
    if (!isValidEmail(user?.email || "")) {
      tMsg.error("Invalid email address");
      return;
    }
    sendRequest();
  };

  const SubmittedElement = () => (
    <>
      <h1 className="font-bold text-lg">Your request has been submitted</h1>
      <div className="text-sm my-4">
        You should receive an email shortly containing a link to reset your MFA
        Token. This URL will expire within 2 hours. Please check your Junk/Spam
        mail folders.
      </div>
      <div className="text-primaryColor opacity-80 hover:opacity-100 transition text-sm font-bold">
        <Link to="/auth">Return to login page</Link>
      </div>
    </>
  );

  const NoUserElement = () => (
    <div className="w-full h-full grid content-center">
      <div className="space-y-4 flex flex-col justify-center">
        <div className="font-medium place-self-center w-72 space-y-4 text-center">
          <div className="text-sm my-4">
            Please login with valid credentials before requesting to reset your
            MFA token
          </div>
          <div className="text-primaryColor opacity-80 hover:opacity-100 transition text-sm font-bold">
            <Link to="/auth">Return to login page</Link>
          </div>
        </div>
      </div>
    </div>
  );

  if (!user || !user.email) return <NoUserElement />;

  return (
    <div className="w-full h-full grid content-center">
      <div className="space-y-4 flex flex-col justify-center">
        <div className="font-medium place-self-center w-64 space-y-4 text-center">
          {!submitted ? (
            <>
              <h1 className="font-bold text-lg">Reset your MFA Token</h1>
              <div className="text-sm">
                When requesting a token reset, a message containing a temporary
                reset URL will be sent to the recovery email associated with
                this account.
              </div>
              {submitting ? (
                <Loader />
              ) : (
                <div className="grid gap-4">
                  <Button
                    className="w-fit place-self-center"
                    type="submit"
                    onClick={(e) => {
                      e.preventDefault();
                      handleSubmit();
                    }}
                  >
                    Reset my MFA token
                  </Button>
                  <div className="text-primaryColor hover:opacity-70 transition text-sm font-bold">
                    <Link to="/auth">Cancel</Link>
                  </div>
                </div>
              )}
            </>
          ) : (
            <SubmittedElement />
          )}
        </div>
      </div>
    </div>
  );
};

export default RequestMFAReset;
